// components/InfoCard.tsx
import React, { useState, useEffect } from "react";
import AiGeneratedLabel from "./AiGeneratedLabel";
import CustomModal from "../../../../../../layout/components/customModal";
import "./style.scss";
const InfoCard = ({ title, executiveSummary, 
// textinfo,
data, layoutStyle = {}, titleStyle = {}, textInfoStyle = {}, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const [modalVisible, setModalVisible] = useState(false);
    const [activeTab, setActiveTab] = useState("credit-analysis");
    const [dataAI, setDataAI] = useState((_a = data === null || data === void 0 ? void 0 : data.analysis_report) === null || _a === void 0 ? void 0 : _a.json_report);
    useEffect(() => {
        var _a;
        setDataAI((_a = data === null || data === void 0 ? void 0 : data.analysis_report) === null || _a === void 0 ? void 0 : _a.json_report);
    }, [data]);
    const handleViewMore = () => {
        setModalVisible(true);
    };
    const handleCloseModal = () => {
        setModalVisible(false);
    };
    const handleTabChange = (tabKey) => {
        setActiveTab(tabKey);
    };
    const getDateRangeText = () => {
        var _a, _b;
        if (!((_a = data === null || data === void 0 ? void 0 : data.metadata) === null || _a === void 0 ? void 0 : _a.start_date) || !((_b = data === null || data === void 0 ? void 0 : data.metadata) === null || _b === void 0 ? void 0 : _b.end_date)) {
            return "Last 12 Months";
        }
        try {
            const startDate = new Date(data.metadata.start_date[0], data.metadata.start_date[1] - 1, data.metadata.start_date[2]);
            const endDate = new Date(data.metadata.end_date[0], data.metadata.end_date[1] - 1, data.metadata.end_date[2]);
            let monthDiff = (endDate.getFullYear() - startDate.getFullYear()) * 12 +
                (endDate.getMonth() - startDate.getMonth());
            if (endDate.getDate() < startDate.getDate()) {
                monthDiff--;
            }
            const totalMonths = monthDiff + 1;
            return `Last ${totalMonths} Month${totalMonths > 1 ? "s" : ""}`;
        }
        catch (error) {
            return "Last 12 Months";
        }
    };
    return (React.createElement("div", { className: "info-card" },
        React.createElement("div", { style: Object.assign(Object.assign({}, layoutStyle), { 
                // backgroundColor: "#000",
                // border: "1px solid #E98C25",
                borderRadius: "6px", padding: "15px 20px 15px 15px", color: "#000000", 
                // fontSize: "14px",
                // fontWeight: "400",
                lineHeight: "120%", letterSpacing: "0.19px" }) },
            title && (React.createElement("div", { style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "15px",
                } },
                React.createElement("div", { style: {
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                    } },
                    React.createElement("h4", { style: Object.assign(Object.assign({}, titleStyle), { marginBottom: "3px" }) }, title),
                    React.createElement(AiGeneratedLabel, null),
                    React.createElement("p", { style: {
                            fontSize: "14px",
                            color: "#0c0d19",
                            fontWeight: "bold",
                        } }, "(Disclaimer: No external data is used for AI Analysis)")),
                React.createElement("div", { style: { display: "flex", alignItems: "center", gap: "15px" } },
                    React.createElement("p", { style: {
                            fontSize: "13px",
                            color: "#0c0d19",
                            fontWeight: 400,
                            margin: 0,
                            padding: 0,
                        } },
                        "Current Month:",
                        " ",
                        React.createElement("span", { style: { fontWeight: "bold" } }, (() => {
                            if ((data === null || data === void 0 ? void 0 : data.current_month) && (data === null || data === void 0 ? void 0 : data.current_year)) {
                                const monthNames = [
                                    "January",
                                    "February",
                                    "March",
                                    "April",
                                    "May",
                                    "June",
                                    "July",
                                    "August",
                                    "September",
                                    "October",
                                    "November",
                                    "December",
                                ];
                                const monthName = monthNames[data.current_month - 1]; // month is 1-indexed
                                return `${monthName} ${data.current_year}`;
                            }
                            return "-/--";
                        })())),
                    React.createElement("p", { style: { fontSize: "13px", color: "#0c0d19", fontWeight: 400 } },
                        "Data Utilized:",
                        " ",
                        React.createElement("span", { style: { fontWeight: "bold" } }, getDateRangeText()))))),
            dataAI && dataAI.root_cause ? (React.createElement("div", null,
                React.createElement("p", { style: textInfoStyle },
                    dataAI.root_cause,
                    React.createElement("span", { onClick: handleViewMore, style: {
                            color: "#E98C25",
                            fontWeight: "bold",
                            cursor: "pointer",
                            textDecoration: "underline",
                            marginLeft: "5px",
                        } }, "View More")),
                React.createElement("p", { style: { marginBottom: "6px", fontSize: "14px" } },
                    "Confidence:",
                    " ",
                    React.createElement("span", { style: {
                            color: ((_b = dataAI.confidence) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === "low"
                                ? "#e74c3c"
                                : ((_c = dataAI.confidence) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === "medium"
                                    ? "#E98C25"
                                    : ((_d = dataAI.confidence) === null || _d === void 0 ? void 0 : _d.toLowerCase()) === "high"
                                        ? "#27ae60"
                                        : "#2c3e50",
                            fontWeight: "bold",
                        } }, dataAI.confidence)),
                ((_f = (_e = data === null || data === void 0 ? void 0 : data.analysis_report) === null || _e === void 0 ? void 0 : _e.metadata) === null || _f === void 0 ? void 0 : _f.escalation_comment) && (React.createElement("p", { style: { fontSize: "14px" } },
                    "Note:",
                    " ",
                    React.createElement("span", { style: {
                        // fontWeight: "bold",
                        } }, (_h = (_g = data === null || data === void 0 ? void 0 : data.analysis_report) === null || _g === void 0 ? void 0 : _g.metadata) === null || _h === void 0 ? void 0 : _h.escalation_comment))))) : (React.createElement("p", { style: textInfoStyle }, "No Root Cause Analysis performed, as the KPI is not at risk."))),
        React.createElement(CustomModal, { visible: modalVisible, onCancel: handleCloseModal, maskClosable: false, destroyOnClose: true, footer: null, 
            // title={["Full BIG Analysis"]}
            width: "60%", modelClass: "info-card-modal" },
            React.createElement("div", { style: { padding: "1rem" } },
                React.createElement("div", { style: {
                        display: "flex",
                        borderBottom: "1px solid #e8e8e8",
                        marginBottom: "20px",
                        justifyContent: "center",
                        marginTop: "10px",
                    } },
                    React.createElement("button", { onClick: () => handleTabChange("credit-analysis"), style: {
                            padding: "10px 20px",
                            border: "none",
                            background: activeTab === "credit-analysis" ? "#17a99a" : "transparent",
                            color: activeTab === "credit-analysis" ? "white" : "#666",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: activeTab === "credit-analysis" ? 600 : 400,
                            borderTopLeftRadius: "6px",
                            borderTopRightRadius: "6px",
                            transition: "all 0.3s ease",
                            width: "33%",
                        } }, "Credit Analysis"),
                    React.createElement("button", { onClick: () => handleTabChange("additional-insights-analysis"), style: {
                            padding: "10px 20px",
                            border: "none",
                            background: activeTab === "additional-insights-analysis"
                                ? "#17a99a"
                                : "transparent",
                            color: activeTab === "additional-insights-analysis"
                                ? "white"
                                : "#666",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: activeTab === "additional-insights-analysis" ? 600 : 400,
                            borderTopLeftRadius: "6px",
                            borderTopRightRadius: "6px",
                            transition: "all 0.3s ease",
                            width: "33%",
                        } }, "Additional Insights Into RCA"),
                    React.createElement("button", { onClick: () => handleTabChange("summaryprotocol-AI-analysis"), style: {
                            padding: "10px 20px",
                            border: "none",
                            background: activeTab === "summaryprotocol-AI-analysis"
                                ? "#17a99a"
                                : "transparent",
                            color: activeTab === "summaryprotocol-AI-analysis"
                                ? "white"
                                : "#666",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: activeTab === "summaryprotocol-AI-analysis" ? 600 : 400,
                            borderTopLeftRadius: "6px",
                            borderTopRightRadius: "6px",
                            transition: "all 0.3s ease",
                            width: "33%",
                        } }, "Protocols Summary")),
                React.createElement("div", null,
                    activeTab === "credit-analysis" && (React.createElement("div", { style: { height: "400px", overflowY: "auto" } }, dataAI && dataAI.credit_analysis ? (React.createElement(React.Fragment, null,
                        React.createElement("div", { style: {
                                fontSize: "14px",
                                lineHeight: "1.6",
                                color: "#2c3e50",
                                margin: 0,
                                whiteSpace: "pre-line",
                            } }, (() => {
                            // Parse the credit analysis text to handle asterisks and formatting
                            const formatCreditAnalysisText = (text) => {
                                if (!text)
                                    return text;
                                // Split the text into lines to handle each list item separately
                                const lines = text.split("\n");
                                return lines.map((line, lineIndex) => {
                                    if (!line.trim())
                                        return null;
                                    let formattedLine = line;
                                    // Replace **text** with <strong>text</strong>
                                    formattedLine = formattedLine.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
                                    // Replace ***text*** with <strong style="color: #E98C25">text</strong>
                                    formattedLine = formattedLine.replace(/\*\*\*(.*?)\*\*\*/g, '<strong style="color: #E98C25">$1</strong>');
                                    // Replace only the first * in this line with a span element
                                    formattedLine = formattedLine.replace(/\*/, '<span class="first-asterisk">*</span>');
                                    // Split by HTML tags and process
                                    const parts = formattedLine.split(/(<[^>]+>.*?<\/[^>]+>)/);
                                    return (React.createElement("div", { key: lineIndex, style: { marginBottom: "8px" } }, parts.map((part, partIndex) => {
                                        if (part.startsWith("<strong")) {
                                            // Extract the text content from the strong tag
                                            const textContent = part.replace(/<[^>]+>/g, "");
                                            return (React.createElement("span", { key: partIndex, style: {
                                                    fontWeight: "bold",
                                                    color: "#000000",
                                                } }, textContent));
                                        }
                                        else if (part.startsWith('<span class="first-asterisk">')) {
                                            // First asterisk wrapped in span
                                            return (React.createElement("span", { key: partIndex, style: {
                                                    fontWeight: "bold",
                                                    color: "#000000",
                                                    fontSize: "20px",
                                                    marginRight: "7px",
                                                } }, "\u2022"));
                                        }
                                        else if (part === "•") {
                                            // Single bullet point
                                            return (React.createElement("span", { key: partIndex, style: {
                                                    display: "inline-block",
                                                    width: "4px",
                                                    height: "4px",
                                                    backgroundColor: "#000000",
                                                    borderRadius: "50%",
                                                    margin: "0 4px",
                                                    verticalAlign: "middle",
                                                } }));
                                        }
                                        else if (part.trim()) {
                                            // Regular text - capitalize first letter of each sentence
                                            const sentences = part.split(". ");
                                            return sentences.map((sentence, sentenceIndex) => {
                                                if (sentence.trim()) {
                                                    const capitalizedSentence = sentence.charAt(0).toUpperCase() +
                                                        sentence.slice(1);
                                                    return (React.createElement("span", { key: `${partIndex}-${sentenceIndex}` },
                                                        capitalizedSentence,
                                                        sentenceIndex <
                                                            sentences.length - 1
                                                            ? ". "
                                                            : ""));
                                                }
                                                return null;
                                            });
                                        }
                                        return null;
                                    })));
                                });
                            };
                            return formatCreditAnalysisText(dataAI.credit_analysis);
                        })()),
                        React.createElement("h4", { style: {
                                fontSize: "18px",
                                fontWeight: 600,
                                marginTop: "20px",
                                marginBottom: "13px",
                            } }, "Component Level Analysis"),
                        dataAI.component_analysis &&
                            Object.keys(dataAI.component_analysis).length > 0 ? (React.createElement("ul", { style: {
                                listStyle: "none",
                                padding: 0,
                                marginLeft: "5px",
                            } }, Object.entries(dataAI.component_analysis).map(([key, value], index) => {
                            // Parse the value to handle asterisks and formatting
                            const formatComponentText = (text) => {
                                if (!text)
                                    return text;
                                // Split the text into lines to handle each list item separately
                                const lines = text.split("\n");
                                return lines.map((line, lineIndex) => {
                                    if (!line.trim())
                                        return null;
                                    let formattedLine = line;
                                    // Replace **text** with <strong>text</strong>
                                    formattedLine = formattedLine.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
                                    // Replace ***text*** with <strong style="color: #E98C25">text</strong>
                                    formattedLine = formattedLine.replace(/\*\*\*(.*?)\*\*\*/g, '<strong style="color: #E98C25">$1</strong>');
                                    // Replace only the first * in this line with a span element
                                    formattedLine = formattedLine.replace(/\*/, '<span class="first-asterisk">*</span>');
                                    // Split by HTML tags and process
                                    const parts = formattedLine.split(/(<[^>]+>.*?<\/[^>]+>)/);
                                    return (React.createElement("div", { key: lineIndex, style: { marginBottom: "4px" } }, parts.map((part, partIndex) => {
                                        if (part.startsWith("<strong")) {
                                            // Extract the text content from the strong tag
                                            const textContent = part.replace(/<[^>]+>/g, "");
                                            return (React.createElement("span", { key: partIndex, style: {
                                                    fontWeight: "bold",
                                                    color: "#000000",
                                                } }, textContent));
                                        }
                                        else if (part.startsWith('<span class="first-asterisk">')) {
                                            // First asterisk wrapped in span
                                            return (React.createElement("span", { key: partIndex, style: {
                                                    fontWeight: "bold",
                                                    color: "#000000",
                                                    fontSize: "20px",
                                                    marginRight: "7px",
                                                } }, "\u2022"));
                                        }
                                        else if (part === "•") {
                                            // Single bullet point
                                            return (React.createElement("span", { key: partIndex, style: {
                                                    display: "inline-block",
                                                    width: "4px",
                                                    height: "4px",
                                                    backgroundColor: "#000000",
                                                    borderRadius: "50%",
                                                    margin: "0 4px",
                                                    verticalAlign: "middle",
                                                } }));
                                        }
                                        else if (part.trim()) {
                                            // Regular text - capitalize first letter of each sentence
                                            const sentences = part.split(". ");
                                            return sentences.map((sentence, sentenceIndex) => {
                                                if (sentence.trim()) {
                                                    const capitalizedSentence = sentence
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                        sentence.slice(1);
                                                    return (React.createElement("span", { key: `${partIndex}-${sentenceIndex}` },
                                                        capitalizedSentence,
                                                        sentenceIndex <
                                                            sentences.length - 1
                                                            ? ". "
                                                            : ""));
                                                }
                                                return null;
                                            });
                                        }
                                        return null;
                                    })));
                                });
                            };
                            return (React.createElement("li", { key: index, style: {
                                    display: "flex",
                                    alignItems: "flex-start",
                                    marginBottom: "10px",
                                    fontSize: "14px",
                                    lineHeight: "1.4",
                                    color: "#000000",
                                } },
                                React.createElement("span", { style: {
                                        width: "4px",
                                        height: "4px",
                                        backgroundColor: "#000000",
                                        borderRadius: "50%",
                                        marginRight: "10px",
                                        marginTop: "8px",
                                        flexShrink: 0,
                                        color: "#000000",
                                    } }),
                                React.createElement("div", { style: { flex: 1 } },
                                    React.createElement("strong", { style: {
                                            fontSize: "14px",
                                            fontWeight: 600,
                                        } },
                                        key,
                                        ":"),
                                    React.createElement("span", { style: {
                                            fontSize: "14px",
                                            fontWeight: 400,
                                            marginLeft: "5px",
                                            color: "#2C3E50",
                                        } }, formatComponentText(value)))));
                        }))) : (React.createElement("p", null, "No component analysis data available")))) : (React.createElement("p", null, "No credit analysis data available")))),
                    activeTab === "additional-insights-analysis" && (React.createElement("div", { style: { height: "400px", overflowY: "auto" } }, data && ((_j = data === null || data === void 0 ? void 0 : data.analysis_report) === null || _j === void 0 ? void 0 : _j.pre_analysis_answers) && ((_k = data === null || data === void 0 ? void 0 : data.analysis_report) === null || _k === void 0 ? void 0 : _k.pre_analysis_answers.length) > 0 ? (React.createElement(React.Fragment, null,
                        React.createElement("div", { style: { marginBottom: "20px" } },
                            React.createElement("p", { style: {
                                    fontSize: "14px",
                                    color: "#666",
                                    marginBottom: "15px",
                                    textAlign: "center",
                                } },
                                "Pre-analysis answers for period:",
                                " ",
                                React.createElement("strong", null, ((_m = (_l = data === null || data === void 0 ? void 0 : data.analysis_report) === null || _l === void 0 ? void 0 : _l.pre_analysis_answers[0]) === null || _m === void 0 ? void 0 : _m.period) || "N/A"))),
                        React.createElement("div", { style: { overflowX: "auto" } },
                            React.createElement("table", { style: {
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    border: "1px solid #e8e8e8",
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                } },
                                React.createElement("thead", null,
                                    React.createElement("tr", { style: { backgroundColor: "#f8f9fa" } },
                                        React.createElement("th", { style: {
                                                padding: "12px 8px",
                                                textAlign: "left",
                                                borderBottom: "2px solid #dee2e6",
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                color: "#2c3e50",
                                                minWidth: "120px",
                                            } }, "Anomalies"),
                                        React.createElement("th", { style: {
                                                padding: "12px 8px",
                                                textAlign: "center",
                                                borderBottom: "2px solid #dee2e6",
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                color: "#2c3e50",
                                                minWidth: "100px",
                                            } }, "Direction"),
                                        React.createElement("th", { style: {
                                                padding: "12px 8px",
                                                textAlign: "center",
                                                borderBottom: "2px solid #dee2e6",
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                color: "#2c3e50",
                                                minWidth: "100px",
                                            } }, "Month on Month Variance %"),
                                        React.createElement("th", { style: {
                                                padding: "12px 8px",
                                                textAlign: "left",
                                                borderBottom: "2px solid #dee2e6",
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                color: "#2c3e50",
                                                minWidth: "120px",
                                            } }, "Accountant Response"),
                                        React.createElement("th", { style: {
                                                padding: "12px 8px",
                                                textAlign: "left",
                                                borderBottom: "2px solid #dee2e6",
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                color: "#2c3e50",
                                                minWidth: "120px",
                                            } }, "Reasons"),
                                        React.createElement("th", { style: {
                                                padding: "12px 8px",
                                                textAlign: "left",
                                                borderBottom: "2px solid #dee2e6",
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                color: "#2c3e50",
                                                minWidth: "120px",
                                            } }, "Additional Details"))),
                                React.createElement("tbody", null, (_o = data === null || data === void 0 ? void 0 : data.analysis_report) === null || _o === void 0 ? void 0 : _o.pre_analysis_answers.map((answer, index) => {
                                    var _a;
                                    return (React.createElement("tr", { key: answer.id || index, style: {
                                            backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8f9fa",
                                            borderBottom: "1px solid #e8e8e8",
                                        } },
                                        React.createElement("td", { style: {
                                                padding: "12px 8px",
                                                fontWeight: 600,
                                                color: "#2c3e50",
                                                borderRight: "1px solid #e8e8e8",
                                            } }, answer.rootCause),
                                        React.createElement("td", { style: {
                                                padding: "12px 8px",
                                                textAlign: "center",
                                                borderRight: "1px solid #e8e8e8",
                                            } },
                                            React.createElement("span", { style: {
                                                    padding: "4px 12px",
                                                    borderRadius: "20px",
                                                    fontSize: "14px",
                                                    // fontWeight: 600,
                                                    color: "#000000",
                                                    // backgroundColor:
                                                    //   answer.direction === "Increase"
                                                    //     ? "#e8f5e8"
                                                    //     : "#ffe8e8",
                                                    // color:
                                                    //   answer.direction === "Increase"
                                                    //     ? "#27ae60"
                                                    //     : "#e74c3c",
                                                } }, answer.direction)),
                                        React.createElement("td", { style: {
                                                padding: "12px 8px",
                                                textAlign: "center",
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                color: "#2c3e50",
                                                borderRight: "1px solid #e8e8e8",
                                            } }, (_a = answer.varianceMateriality) === null || _a === void 0 ? void 0 :
                                            _a.toFixed(2),
                                            "%"),
                                        React.createElement("td", { style: {
                                                padding: "12px 8px",
                                                fontSize: "14px",
                                                color: "#2c3e50",
                                                borderRight: "1px solid #e8e8e8",
                                            } }, answer.requireReview || (React.createElement("span", { style: {
                                                color: "#999",
                                                fontSize: "12px",
                                            } }, "No response"))),
                                        React.createElement("td", { style: {
                                                padding: "12px 8px",
                                                borderRight: "1px solid #e8e8e8",
                                            } }, answer.reasons &&
                                            answer.reasons.length > 0 ? (React.createElement("div", { style: {
                                                display: "flex",
                                                flexWrap: "wrap",
                                                gap: "4px",
                                            } }, answer.reasons.map((reason, reasonIndex) => (React.createElement("span", { key: reason.id || reasonIndex, style: {
                                                backgroundColor: "#e8f5e8",
                                                color: "#27ae60",
                                                padding: "3px 8px",
                                                borderRadius: "12px",
                                                fontSize: "12px",
                                                fontWeight: 500,
                                            } }, reason.reason))))) : (React.createElement("span", { style: {
                                                color: "#999",
                                                fontSize: "12px",
                                            } }, "No reasons"))),
                                        React.createElement("td", { style: {
                                                padding: "12px 8px",
                                                fontSize: "14px",
                                                color: "#2c3e50",
                                                borderRight: "1px solid #e8e8e8",
                                            } }, answer.otherReason || (React.createElement("span", { style: {
                                                color: "#999",
                                                fontSize: "12px",
                                            } }, "None")))));
                                })))))) : (React.createElement("p", { style: {
                            textAlign: "center",
                            color: "#666",
                            fontSize: "14px",
                            marginTop: "50px",
                        } }, "No anomalies were identified for this KPI")))),
                    activeTab === "summaryprotocol-AI-analysis" && (React.createElement("div", { style: { height: "400px", overflowY: "auto" } },
                        React.createElement("div", { style: { padding: "20px", borderRadius: "8px" } },
                            React.createElement("div", { style: { marginBottom: "20px" } },
                                React.createElement("h5", { style: {
                                        color: "#34495e",
                                        marginBottom: "10px",
                                        fontSize: "16px",
                                        fontWeight: 600,
                                        display: "flex",
                                    } },
                                    "Data Usage:",
                                    " ",
                                    React.createElement("span", { style: {
                                            fontSize: "14px",
                                            lineHeight: "1.6",
                                            color: "#2c3e50",
                                            margin: 0,
                                        } },
                                        React.createElement("p", { style: {
                                                fontSize: "14px",
                                                lineHeight: "1.6",
                                                color: "#2c3e50",
                                                margin: 0,
                                                paddingTop: "2px",
                                            } },
                                            React.createElement("strong", null,
                                                " ",
                                                "No data is utilized outside of RodaBI.")))),
                                React.createElement("p", { style: {
                                        fontSize: "14px",
                                        lineHeight: "1.6",
                                        color: "#2c3e50",
                                        margin: "10px 0 0 0",
                                    } },
                                    "For analysis, Sophia uses",
                                    " ",
                                    React.createElement("strong", null, "12 months of data"),
                                    " from the following sources:"),
                                React.createElement("ul", { style: { margin: "10px 0 0 20px", color: "#2c3e50" } },
                                    React.createElement("li", null, "KPI (Key Performance Indicators)"),
                                    React.createElement("li", null, "Balance Sheet"),
                                    React.createElement("li", null, "Cashflow"),
                                    React.createElement("li", null, "Profit and Loss"))),
                            React.createElement("div", { style: { marginBottom: "20px" } },
                                React.createElement("h5", { style: {
                                        color: "#34495e",
                                        marginBottom: "10px",
                                        fontSize: "16px",
                                        fontWeight: 600,
                                    } }, "Automated Analysis Conditions"),
                                React.createElement("p", { style: {
                                        fontSize: "14px",
                                        lineHeight: "1.6",
                                        color: "#2c3e50",
                                        margin: 0,
                                    } }, "Three conditions under which automated analysis is performed:"),
                                React.createElement("ul", { style: { margin: "10px 0 0 20px", color: "#2c3e50" } },
                                    React.createElement("li", null,
                                        "KPI current rating changes and remains in",
                                        " ",
                                        React.createElement("strong", { style: { color: "#0c0d19" } },
                                            React.createElement("strong", { style: { color: "#FFA500" } }, "C"),
                                            " or",
                                            " ",
                                            React.createElement("strong", { style: { color: "#FF0000" } }, "D"))),
                                    React.createElement("li", null,
                                        "KPI predicted rating changes and remains in",
                                        " ",
                                        React.createElement("strong", { style: { color: "#0c0d19" } },
                                            React.createElement("strong", { style: { color: "#FFA500" } }, "C"),
                                            " or",
                                            " ",
                                            React.createElement("strong", { style: { color: "#FF0000" } }, "D"))),
                                    React.createElement("li", null,
                                        "KPI current or predicted rating is in",
                                        " ",
                                        React.createElement("strong", { style: { color: "#0c0d19" } },
                                            React.createElement("strong", { style: { color: "#FFA500" } }, "C"),
                                            " or",
                                            " ",
                                            React.createElement("strong", { style: { color: "#FF0000" } }, "D"))))),
                            React.createElement("div", { style: { marginBottom: "20px" } },
                                React.createElement("h5", { style: {
                                        color: "#34495e",
                                        marginBottom: "10px",
                                        fontSize: "16px",
                                        fontWeight: 600,
                                    } }, "Manual Intervention"),
                                React.createElement("p", { style: {
                                        fontSize: "14px",
                                        lineHeight: "1.6",
                                        color: "#2c3e50",
                                        margin: 0,
                                    } },
                                    "Analysis can be fetched for KPIs with ratings either in",
                                    " ",
                                    React.createElement("strong", { style: { color: "#0c0d19" } },
                                        React.createElement("strong", { style: { color: "#27ae60" } }, "A"),
                                        " or",
                                        " ",
                                        React.createElement("strong", { style: { color: "#FFFF00" } }, "B")),
                                    " ",
                                    "with manual intervention.")),
                            React.createElement("div", null,
                                React.createElement("h5", { style: {
                                        color: "#34495e",
                                        marginBottom: "10px",
                                        fontSize: "16px",
                                        fontWeight: 600,
                                    } }, "Anomalies Handling Process"),
                                React.createElement("p", { style: {
                                        fontSize: "14px",
                                        lineHeight: "1.6",
                                        color: "#2c3e50",
                                        margin: 0,
                                    } }, "Five-step process for handling detected anomalies:"),
                                React.createElement("ol", { style: { margin: "10px 0 0 20px", color: "#2c3e50" } },
                                    React.createElement("li", null,
                                        "If anomalies are detected, Sophia sends questions to the",
                                        " ",
                                        React.createElement("strong", null, "accountant/site admin"),
                                        "."),
                                    React.createElement("li", null, "If answers are received, they are incorporated into the analysis."),
                                    React.createElement("li", null,
                                        "If no response is received, Sophia sends a",
                                        " ",
                                        React.createElement("strong", null, "reminder"),
                                        "."),
                                    React.createElement("li", null,
                                        "If there is still no response within",
                                        " ",
                                        React.createElement("strong", null, "2 days"),
                                        ", Sophia escalates the query by sending an ",
                                        React.createElement("strong", null, "email to the group admin"),
                                        "."),
                                    React.createElement("li", null,
                                        "If no response is received after escalation, Sophia proceeds with the analysis, but includes a",
                                        " ",
                                        React.createElement("strong", null, "disclaimer"),
                                        " and marks the results as",
                                        " ",
                                        React.createElement("strong", null, "low confidence"),
                                        ".")))))))))));
};
export default InfoCard;
